<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  name: "PurchaseOrder",
  components: {
    Multiselect,
    DatePicker
  },
  data() {
    return {
      dateVal: new Date(),
      itemList: [],
      storeList: [],
      selected_items: [],
      filterObj: {
        source_store_id: "",
        destination_store_id: ""
      },
      order: {
        id: null,
        source_store: null,
        items: [],
        destination_store: null,
        note: null,
        transfer_status: null,
        transfer_date: null
      },
      note_count: 0,
      disabledDates: {
        to: new Date()
      }
    };
  },
  methods: {
    onDestinationStoreChange() {
      this.itemList = [];
      if (this.filterObj.destination_store_id) {
        this.order.destination_store = this.filterObj.destination_store_id;
      }
      if (
        this.filterObj.destination_store_id != "" &&
        this.filterObj.source_store_id == this.filterObj.destination_store_id
      ) {
        this.filterObj.destination_store_id = "";
        this.$notify({
          group: "foo",
          text: this.$lang.messages.destination_store_can_not_be_the_same_as_source_store,
          type: "error"
        });
        return false;
      }
      this.getItemList();
    },
    onSourceStoreChange() {
      this.itemList = [];
      if (this.filterObj.source_store_id) {
        this.order.source_store = this.filterObj.source_store_id;
      }
      if (
        this.filterObj.source_store_id != "" &&
        this.filterObj.source_store_id == this.filterObj.destination_store_id
      ) {
        this.filterObj.source_store_id = "";
        this.$notify({
          group: "foo",
          text: this.$lang.messages.destination_store_can_not_be_the_same_as_source_store,
          type: "error"
        });
        return false;
      }
      this.getItemList();
    },
    getItemList() {
      if (
        this.filterObj.destination_store_id != "" &&
        this.filterObj.source_store_id != ""
      ) {
        this.$api
          .getAPI({ _action: "/item/item_transfer", _body: this.filterObj })
          .then(res => {
            if (res.list != null && res.list.length > 0) {
              this.itemList = res.list;
              this.selected_items = [];
            }
            this.$validator.reset();
            this.errors.clear();
          })
          .catch(e => {});
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    removeSelectedItem(index) {
      this.selected_items.splice(index, 1);
    },
    validateForm(status) {
      if (status) {
        this.order.transfer_status = status;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          if (
            this.filterObj.source_store_id ==
            this.filterObj.destination_store_id
          ) {
            this.filterObj.destination_store_id = "";
            this.$notify({
              group: "foo",
              text: this.$lang.messages.destination_store_can_not_be_the_same_as_source_store,
              type: "error"
            });
            return false;
          }
          this.save();
          return;
        }
      });
    },
    save() {
      this.order.items = this.selected_items;
      this.order.transfer_date = moment(
        String(this.order.transfer_date)
      ).format("Y-M-D");
      this.$api
        .postAPI({
          _action: "/transfer-order/",
          _body: this.order,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/transfer-orders");
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    details(id) {
      this.order = {};
      this.selected_items = [];

      this.$api
        .getAPI({
          _action: "/transfer-order/detail/" + id
        })
        .then(res => {
          this.order = res.transfer_order;

          if (this.order.note) {
            this.note_count = this.order.note.length;
          }

          setTimeout(() => {
            for (var i = 0; i < res.items.length; i++) {
              if (res.items[i].item) {
                this.selected_items.push(res.items[i].item);
              }
            }
          }, 500);

          this.filterObj.source_store_id = this.order.source_store;
          this.filterObj.destination_store_id = this.order.destination_store;
          this.order.transfer_date = new Date(this.order.transfer_date);
          this.getItemList();
        });
    },
    changeNoteCount() {
      if (this.note_count >= 300) {
        this.order.note = this.order.note.substring(0, 300);
        this.note_count = 300;
      }
      this.note_count = this.order.note.length;
    }
  },
  mounted() {
    var currentDate = new Date();
    this.order.transfer_date = currentDate;
    this.getStoreList();
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="row mb-lg-4 mb-3">
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.source_store}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        v-model="filterObj.source_store_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('source_store_id') }"
                        @change="onSourceStoreChange()"
                        v-validate="'required'"
                        name="source_store_id"
                      >
                        <option value>{{$lang.messages.select_source_store}}</option>
                        <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>

                      <i v-show="errors.has('source_store_id')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('source_store_id')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_source_store}}</span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.destination_store}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        v-model="filterObj.destination_store_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('destination_store_id') }"
                        @change="onDestinationStoreChange()"
                        v-validate="'required'"
                        name="destination_store_id"
                      >
                        <option value>{{$lang.messages.select_destination_store}}</option>
                        <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.date_of_transfer_order}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="input-group">
                      <date-picker
                        v-validate="'required'"
                        v-model="order.transfer_date"
                        style="width:480px;"
                        format="DD-MM-YYYY"
                        :disabled-dates="disabledDates"
                        :class="['input w-xs-100', {'is-danger': errors.has('transfer_date') }]"
                        lang="en"
                        name="transfer_date"></date-picker>

                      <i v-show="errors.has('transfer_date')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('transfer_date')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_transfer_date}}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <label for>{{$lang.messages.notes}}</label>
                    <label class="float-right">{{note_count}} / 300</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      :placeholder="$lang.messages.write_here_something"
                      style="height: auto"
                      v-model="order.note"
                      maxlength="300"
                      v-on:keyup="changeNoteCount()"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9">
            <div class="card mb-0 rounded-5 border">
              <div class="card-header px-4 mt-1 py-3 bg-white border-bottom">
                <h3 class="font-22 d-inline-block">{{$lang.messages.items}}</h3>
                <div class="selectbox-xs custom-select-dd float-right" style="width: 275px"></div>
              </div>
              <div class="card-body form-style px-4">
                <div class="table-responsive">
                  <table class="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" width="150">{{$lang.messages.selected_items}}</th>
                        <th scope="col" width="150">{{$lang.messages.source_stock}}</th>
                        <th scope="col">{{$lang.messages.destination_stock}}</th>
                        <th scope="col">{{$lang.messages.quantity}}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, index)  in selected_items" :key="'composite_item_'+index">
                        <td class="align-middle">
                          <span class="f-semi-bold">{{sel.name}}</span>
                          <br />
                          <span v-if="sel.sku">{{$lang.messages.sku}} {{sel.sku}}</span>
                        </td>
                        <td class="align-middle">{{sel.source_stock}}</td>
                        <td class="align-middle">{{sel.destination_stock}}</td>
                        <td class="align-middle">
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.quantity"
                            :id="'composite_item_quantity_' + index"
                            :name="'composite_item_quantity_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                            v-validate="'required|decimal|min_value:1|max_value:' + sel.source_stock "
                          />
                          <i
                            v-show="errors.has('composite_item_quantity_'+ index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('composite_item_quantity_'+ index)"
                            class="help is-danger">
                            <div v-if="sel.source_stock <= 0">{{$lang.messages.this_item_is_out_of_stock}}</div>
                            <div v-else-if="sel.quantity > sel.source_stock">{{$lang.messages.only_in_stock.replace("QUANTITY", sel.source_stock)}}</div>
                            <div v-else>{{$lang.messages.please_enter_valid_quantity}}</div>
                          </span>
                        </td>
                        <td class="align-middle">
                          <a href="javascript:void(0)" @click="removeSelectedItem(index)">
                            <i class="far fa-trash-alt font-20 text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div>
                      <label class="typo__label">{{$lang.messages.item_search}}</label>
                      <span style="color:#ff0000">*</span>

                      <multiselect
                        v-validate="'required'"
                        v-model="selected_items"
                        :options="itemList"
                        :multiple="true"
                        :class="{'input': true, 'is-danger': errors.has('searchItem') }"
                        :close-on-select="true"
                        :clear-on-select="false"
                        v-bind:placeholder="$lang.messages.please_select_option"
                        label="name"
                        track-by="name"
                        name="searchItem"
                        :select-label="$lang.messages.please_enter_to_select"
                        :deselect-label="$lang.messages.please_enter_to_remove"
                        :selected-label="$lang.messages.selected"
                      >
                        <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
                        <template slot="selection">
                          <span class="multiselect__single" v-if="selected_items.length"></span>
                        </template>
                      </multiselect>

                      <i v-show="errors.has('searchItem')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('searchItem')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_atleast_one_item}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9 text-right">
            <button
              type="button"
              class="btn btn-primary mr-3 mb-lg-0 mt-3"
              id="save-btn"
              @click="validateForm()">
              <span v-if="this.$route.params.id">{{$lang.messages.save}}</span>
              <span v-else>{{$lang.messages.create}}</span>
            </button>
            <button
              type="button"
              class="btn btn-primary mr-lg-3 mr-2 mt-3"
              @click="validateForm('TRANSFERRED')">
              <span v-if="this.$route.params.id">{{$lang.messages.save_and_receive}}</span>
              <span v-else>{{$lang.messages.create_and_receive}}</span>
            </button>
            <button
              type="submit"
              class="btn btn-outline-primary mt-3"
              id="cancel-btn"
              @click="$router.go(-1)"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
